/*
 * badge will be positioned absolutely at the bottom right of parent by default.
 * use as inline element with 'static' badgePosition prop.
 */
import { useRef } from "react";
import cx from "ui/cx";
import IconHigharcGrey from "ui/icons/IconHigharcGrey";
import styles from "./PoweredByBadge.module.scss";

type BadgePosition = "topRight" | "bottomRight" | "topLeft" | "bottomLeft" | "static";
interface PoweredByBadgeProps {
  badgePosition?: BadgePosition;
  offsetX?: number;
  offsetY?: number;
}

export default function PoweredByBadge({
  badgePosition = "bottomRight",
  offsetX = 6,
  offsetY = 6,
}: PoweredByBadgeProps) {
  const badgeRef = useRef<HTMLDivElement>(null);
  const classNames = cx({
    styles,
    poweredByGroup: true,
    [badgePosition]: true,
  });

  if (badgeRef.current) {
    const style = badgeRef.current.style;
    style.setProperty("--badge-offset-x", `${offsetX}px`);
    style.setProperty("--badge-offset-y", `${offsetY}px`);
  }

  return (
    <div ref={badgeRef} className={classNames}>
      <IconHigharcGrey width={12} />
      <span>
        Powered by <em>Higharc</em>
      </span>
    </div>
  );
}
